import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { FormsModule } from '@angular/forms';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { PromotionsService } from 'src/app/shared/services/promotions.service';
import { EanOrphelin } from 'src/app/shared/interfaces/promotions/EanOrphelin';
import { PromotionsDetail } from 'src/app/shared/interfaces/promotions/PromotionsDetail';
import { catchError, Subject, takeUntil, tap, throwError } from 'rxjs';
import { SnackbarHelper } from 'src/app/shared/services/snackbar/snackbar.helper';
import { SnackbarService } from 'src/app/shared/services/snackbar/snackbar.service';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-ean-orphelin-attachement',
  standalone: true,
  imports: [
    CommonModule,
    MatRadioModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatTableModule,
  ],
  templateUrl: './ean-orphelin-attachement.component.html',
  styleUrl: './ean-orphelin-attachement.component.scss',
})
export class EanOrphelinAttachementComponent implements OnDestroy {
  private readonly _destroying$ = new Subject<void>();
  eanOrphelinDataSource: MatTableDataSource<EanOrphelin>;
  eanList: PromotionsDetail[] = [];
  displayedColumns: string[] = ['select', 'codeEan', 'designation'];
  selectedEan: any = null;
  selectedProduct: any = null;
  globalFilter: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly promotionsService: PromotionsService,
    private readonly snackbarService: SnackbarService,
  ) {
    this.eanList = data?.componentData?.eanList ?? [];
    this.eanOrphelinDataSource = new MatTableDataSource<EanOrphelin>(
      data?.componentData?.eanOrphelinList ?? [],
    );
  }

  ngOnInit() {
    this.eanOrphelinDataSource.filterPredicate = (data: EanOrphelin, filter: string): boolean => {
      const lowerFilter = filter.toLowerCase();
      return (
        (data.eanOrphelin ?? '').toLowerCase().includes(lowerFilter) ||
        (data.designationOrphelin ?? '').toLowerCase().includes(lowerFilter)
      );
    };

    this.eanOrphelinDataSource.filter = this.globalFilter.trim().toLowerCase();
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }

  onSubmit() {
    if (!!this.selectedProduct?.id && !!this.selectedEan.id)
      this.promotionsService
        .linkEanOrphelinToPromotionProduct(this.selectedEan.id, this.selectedProduct.id)
        .pipe(
          takeUntil(this._destroying$),
          tap((promotionDetail: any) => {
            this.snackbarService.show(
              "L'attachement a bien été effectué.",
              SnackbarHelper.snackbarPanelClassSuccess(),
            );
          }),
          catchError(error => {
            this.snackbarService.show(error.error, SnackbarHelper.snackbarPanelClassError());
            return throwError(() => error.error);
          }),
        )
        .subscribe();
  }

  onCancel() {
    this.selectedEan = null;
    this.selectedProduct = null;
  }

  applyFilter(filterValue: string): void {
    this.globalFilter = filterValue;
    this.eanOrphelinDataSource.filter = this.globalFilter.trim().toLowerCase();
  }
}
